export enum CapabilityModelType {
    IOLink = ':iolink:',
    Analytics = ':analytics:',
}
